import React from 'react';

export const ListRemoveIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/list/remove' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='ci:list-plus' transform='translate(2.500000, 6.666667)' fill='currentColor'>
          <path
            d='M12.5,12.7480159 L0.0992063492,12.7480159 L0.0992063492,10.2678571 L12.5,10.2678571 L12.5,12.7480159 Z M14.4321289,7.78769841 L0.0992063492,7.78769841 L0.0992063492,5.30753968 L14.4321289,5.30753968 L14.4321289,7.78769841 Z M16.2202381,2.82738095 L0.0992063492,2.82738095 L0.0992063492,0.347222222 L16.2202381,0.347222222 L16.2202381,2.82738095 Z'
            id='Shape'
            fillRule='nonzero'
          ></path>
          <polygon
            id='Path'
            transform='translate(19.940476, 11.507937) rotate(-315.000000) translate(-19.940476, -11.507937) '
            points='21.1805556 16.468254 18.7003968 16.468254 18.7003968 12.7480159 14.9801587 12.7480159 14.9801587 10.2678571 18.7003968 10.2678571 18.7003968 6.54761905 21.1805556 6.54761905 21.1805556 10.2678571 24.9007937 10.2678571 24.9007937 12.7480159 21.1805556 12.7480159'
          ></polygon>
        </g>
      </g>
    </svg>
  );
};
